import React from "react"
import { Link } from "gatsby"

const IndustryFooterMenu = () => {
  return (
    <React.Fragment>
      <Link to="/educational-equipment-repair-services">
        Educational Equipment Repair Services
      </Link>
      <Link to="/military-equipment-repair-services">
        Military Equipment Repair Services
      </Link>
      <Link to="/energy-equipment-repair-services">
        Energy Equipment Repair Services
      </Link>
      <Link to="/manufacturing-equipment-repair-services">
        Manufacturing Equipment Repair Services
      </Link>
      <Link to="/retail-equipment-repair-services">
        Retail Equipment Repair Services
      </Link>
      <Link to="/medical-equipment-repair-services">
        Medical Equipment Repair Services
      </Link>
      <Link to="/municipal-equipment-repair-services">
        Municipal Equipment Repair Services
      </Link>
      <Link to="/oil-and-gas-equipment-repair-services">
        Oil & Gas Equipment Repair Services
      </Link>
    </React.Fragment>
  )
}

export default IndustryFooterMenu
